import { type FC } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { PRIMARY_NAV, isNavItemActive } from '@/navigation/navItems';
import { cn } from '@/utils/cn';

/**
 * AppNav - primary navigation for sm screens and up.
 */
export const AppNav: FC = () => {
  const { pathname } = useLocation();
  return (
    <nav aria-label="Main" className="hidden sm:flex items-center gap-1">
      {PRIMARY_NAV.map((item) => {
        const active = isNavItemActive(item, pathname);
        return (
          <Link
            key={item.id}
            to={item.to}
            aria-current={active ? 'page' : undefined}
            className={cn(
              'inline-flex items-center min-h-[44px] px-3 rounded text-sm font-medium border-b-2',
              active ? 'border-accent-primary text-accent-primary' : 'border-transparent text-text-secondary hover:text-text-primary hover:bg-bg-hover',
            )}
          >
            {item.label}
          </Link>
        );
      })}
    </nav>
  );
};
